"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultTheme = {
  colors: {
    base: '#282832',
    outline: '#FFD833',
    primary: '#D1233E',
    red_dvc: '#D1233E',
    dark_grey: '#282832',
    mid_grey: '#777794',
    light_grey: '#EBEBF5',
    green: '#A1CB5B',
    yellow: '#FFD833',
    orange: '#F5813F',
    purple: '#B090C1',
    turquoise: '#59C3C4',
    black: '#000000',
    white: '#FFFFFF',
    facebook: '#3B5998',
    twitter: '#00ACED',
    google_plus: '#DD4B39',
    transparent: 'transparent'
  },
  fonts: {
    primary: 'Nunito, Verdana, "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  spaces: {
    "default": 16,
    large: 16 * 1.5
  },
  breakpoints: {
    small: '34em',
    medium: '48em',
    large: '62em',
    xlarge: '75em',
    xxlarge: '100em'
  },
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 24
};
var _default = defaultTheme;
exports["default"] = _default;